import script from "./VideoSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoSelector.vue?vue&type=script&lang=ts&setup=true"

import "./VideoSelector.vue?vue&type=style&index=0&id=7ee1efd3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee1efd3"]])

export default __exports__